import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowStretchBox12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowStretchBox12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1.5 2h9a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5M0 2.5A1.5 1.5 0 0 1 1.5 1h9A1.5 1.5 0 0 1 12 2.5v7a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 0 9.5zm4.192 4 .912.912a.5.5 0 0 1-.708.707L2.63 6.351l-.354-.353.354-.354 1.767-1.768a.5.5 0 0 1 .708.708l-.917.916h3.621l-.912-.912a.5.5 0 1 1 .708-.707L9.37 5.649l.354.353-.354.354-1.767 1.768a.5.5 0 0 1-.708-.708l.917-.916z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowStretchBox12);
